module.exports = __webpack_public_path__ + "img/scenes_4.355d5618.png";